import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import logo from 'src/logo.png';
import { AppBar, Toolbar, Box } from '@mui/material';

export default function DesktopHeader() {
  const history = useHistory();
  const pathname = history?.location?.pathname;
  const [title, setTitle] = useState('');

  useEffect(() => {
    if (!pathname) return;

    const titles = {
      '/personal-property-settlement-form':
        'Application for Settlement or Deferral of Delinquent Property Tax',
      '/personal-property-appeal-form': 'Personal Property Appeal Form for Penalty Reduction',
      '/real-property-appeal-form': 'Real Property Appeal Form for Penalty Reduction',
    };

    setTitle(titles[pathname] || '');
  }, [pathname]);

  return (
    <div className="hidden sm:block">
      <AppBar position="static" style={{ backgroundColor: 'transparent' }}>
        <Toolbar className="m-auto flex flex-col gap-4 p-2 sm:m-0 sm:flex-row sm:gap-6">
          <Box display="flex">
            <img alt="Logo" className="max-h-16 w-full" src={logo} />
          </Box>
          <p className="font-medium text-black">{title}</p>
        </Toolbar>
      </AppBar>
    </div>
  );
}
